<style scoped>
@import url("../assets/css/contact_us.css");
</style>
<template>
  <div class="contact_us">
    <van-nav-bar @click-left="pageBack" title="联系我们" class="menu-title-box">
      <img slot="left" src="../assets/image/icon_v2/return_white@2x.png" class="return_icon" />
    </van-nav-bar>
    <div class="box">
      <div class="content-block">
        <img src="../assets/image/phone_icon@2x.png" class="img-icon" />
        <p class="font-m">售前咨询</p>
        <a href="tel:025-83420461" class="theme-color font-m phone">025-83420461</a>
      </div>
      <div class="content-block box-top">
        <img src="../assets/image/address_icon@2x.png" class="img-icon" />
        <p class="font-m">集团总部</p>
        <p class>北京市东城区东四十条南新仓商务大厦B618B</p>
      </div>
      <div class="content-block box-top">
        <img src="../assets/image/address_icon@2x.png" class="img-icon" />
        <p class="font-m">运营中心</p>
        <p class>江苏省南京市建邺区广聚路33号 安科大厦A栋1201室</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    pageBack() {
      history.back();
    }
  },
  created(){
    const hashLocation = this.$route.path
		const url = "https://m.kanguji.com"+hashLocation
		this.$matomo.setCustomUrl(url);
  }
};
</script>


// WEBPACK FOOTER //
// src/components/contact_us.vue